export default __webpack_public_path__ + "static/media/sazuvista.2a97eed8.jpeg";